module.exports = __webpack_public_path__ + "static/media/newTabLink.1bd76e1f.svg";